/*
 Translates PROCESSING entries to TIMED_OUT if they have been in the queue for longer than the timeout and have been
 retried the maximum number of times. This is done simply to give the users a better indication of what happened
 instead of "PROCESSING". But much simpler to implement this as a simple translation on DQ item status rather than
 implementing some background process that periodically checks the queue for abandoned items and changes their status.
 */
const DEPLOY_QUEUE_TIMEOUT = 'DEPLOY_QUEUE_TIMEOUT';
const DEPLOY_QUEUE_MAX_RETRY_COUNT = 'DEPLOY_QUEUE_MAX_RETRY_COUNT';
const PROPERTY_SCOPE = 'rckms';

let timeoutPropertiesPromise;

export const getDeployQueueTimeoutProperties = () => {
    if (!timeoutPropertiesPromise) {
        timeoutPropertiesPromise = Promise.all([
            Session.retrieveSystemProperty(DEPLOY_QUEUE_TIMEOUT, PROPERTY_SCOPE),
            Session.retrieveSystemProperty(DEPLOY_QUEUE_MAX_RETRY_COUNT, PROPERTY_SCOPE)
        ]).then(([timeout, maxRetryCount]) => ({
            timeout: Number(timeout),
            maxRetryCount: Number(maxRetryCount)
        }));
    }

    return timeoutPropertiesPromise;
};

export const translateTimedOutStatus = (item, properties, now = Date.now()) => {
    if (item?.status !== 'PROCESSING') {
        return item;
    }

    const retrievedOn = item.retrievedOn;
    const retrievedAt = new Date(retrievedOn).getTime();
    const retrievedCount = Number(item.retrievedCount);
    const { timeout, maxRetryCount } = properties || {};

    if (
        Number.isFinite(retrievedAt) &&
        Number.isFinite(timeout) &&
        Number.isFinite(retrievedCount) &&
        Number.isFinite(maxRetryCount) &&
        now - retrievedAt > timeout &&
        retrievedCount > maxRetryCount
    ) {
        return { ...item, status: 'TIMED_OUT' };
    }

    return item;
};
